// ─── Information Pillar: Data Domain ───────────────────────────────────────

import type { DataDomain } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateDataDomainInput {
  name: string;
  description?: string;
  domainType: string;
  dataStewardId: string;
  owningBusinessUnitId: string;
  technicalOwnerId?: string;
  defaultClassification: string;
  containsPII?: boolean;
  containsPCI?: boolean;
  containsPHI?: boolean;
  complianceFrameworks?: string[];
  retentionPeriodDays?: number;
  lifecycleStatus?: string;
  criticalityLevel: string;
  tags?: string[];
  notes?: string;
  documentationUrl?: string;
}

export interface UpdateDataDomainInput {
  name?: string;
  description?: string;
  domainType?: string;
  dataStewardId?: string;
  owningBusinessUnitId?: string;
  technicalOwnerId?: string;
  defaultClassification?: string;
  containsPII?: boolean;
  containsPCI?: boolean;
  containsPHI?: boolean;
  complianceFrameworks?: string[];
  retentionPeriodDays?: number;
  lifecycleStatus?: string;
  criticalityLevel?: string;
  tags?: string[];
  notes?: string;
  documentationUrl?: string;
}

const client = createEntityCrudClient<DataDomain, CreateDataDomainInput, UpdateDataDomainInput>(
  '/data-domains'
);

export async function createDataDomain(input: CreateDataDomainInput): Promise<DataDomain> {
  return client.create(input);
}

export async function updateDataDomain(
  dataDomainId: string,
  input: UpdateDataDomainInput
): Promise<DataDomain> {
  return client.update(dataDomainId, input);
}

export async function deleteDataDomain(
  dataDomainId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(dataDomainId, hardDelete);
}
